import { useOutletContext, Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { getHomeData } from "../api/services/sahamApi";
import { currencyFormat } from "../components/utils/currencyFormat";
import { formatDate } from "../components/utils/fomatDate";
import Card from "../components/cards/Card";
import TransactionCard from "../components/cards/TransactionCard";


function Home() {
    
    /** Title Header Page */
    const {title, setTitle} = useOutletContext();
    setTitle('Catatan Sembako');
    
    /** useState */
    const [homeData, setHomeData] = useState({
        total_saham_tabungan : 0,
        total_setor : 0 ,
        kurang_setor : 0 ,
        histori_setor : [],
        histori_saham : [],
    });
    
        
    useEffect(() => {
        document.title = 'Catatan Sembako | Sembako';
        getHomeData().then(res => setHomeData(res.data.data));
    },[])

    console.log(homeData);

    return(
        <>
            <div className="card-main total-sembako text-white mt-10 mb-10 p-5 pt-10 pb-10 rounded-xl">
                <h2 class="text-xl ">Total Sembako dan Tabungan</h2>
                <span class="text-6xl ">{currencyFormat(homeData.total_saham_tabungan)}</span>
            </div>
            <div className="grid grid-cols-2 gap-10">
                <div className="rounded-xl bg-gray-50 p-5 pt-10 pb-10">
                    <h3 class="text-x font-semibold">
                        Total yang sudah<br/>disetor
                    </h3>
                    <span className="text-2xl mt-10 block">{currencyFormat(homeData.total_setor)}</span>
                </div>
                <div className="rounded-xl bg-gray-50 p-5 pt-10 pb-10">
                    <h3 class="text-x font-semibold">
                        Total yang belum <br/>disetor
                    </h3>
                    <span className="text-2xl mt-10 block">{currencyFormat(homeData.kurang_setor)}
                    {homeData.kurang_setor < 0 && (
                        <span className="text-sm itali text-green-700 ml-3"> Kelebihan</span>
                    )}
                    </span>
                </div>
            </div>
            <div className="mt-10">
                <div className="flex justify-between items-center">
                    <h3 className="text-xl font-semibold">Transaksi Terakhir</h3>
                    <Link to="daftar-transaksi" className="text-blue-600">Lihat Semua</Link>
                </div>
                    {
                        homeData.histori_saham.map((val, i) => 
                            <TransactionCard 
                                header={`No. ${val.saham.nomer} - ${val.saham.nama}`}
                                type={val.type_transaksi}
                                id={val.id}
                                date={formatDate(val.updated_at)}
                                jumlahSembako={val.jumlah_sembako}
                                jmlSaham={val.jml_saham}
                                nomerSembako={val.nomer_sembako}
                                jumlahTabungan={val.jumlah_tabungan}
                            />
                        )
                    }
            </div>
            <div className="mt-10">
                <div className="flex justify-between items-center">
                    <h3 className="text-xl font-semibold">Setor Terakhir</h3>
                    <Link to="setor" className="text-blue-600">Lihat Semua</Link>
                </div>
                <div className="mt-7">
                    {
                        homeData.histori_setor.map((val, i) => 
                            <Card 
                                header={currencyFormat(val.setor)}
                                textRight={formatDate(val.updated_at)}
                                
                            />
                        )
                    }
                </div>
            </div>
        </>
    );
}

export default Home;